<!--
 * @Author: ZhaoG
 * @Date: 2025-05-28 09:30:33
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-06-06 16:59:14
 * @FilePath: \gcp-fe\src\app\shop\components\fenBaoDetail.vue
 * @Description: 分包详情
-->
<template>
  <div class="wrapper">
    <div style="display: flex; align-items: center;">
      <base-bread-crumb
        :currBreadCrumb="currBreadCrumb"
        :isShowPortal="false"
      ></base-bread-crumb>
    </div>
    <div class="ccui-notice-app-container-detail">
      <div class="ccui-notice-app-container-detail-body clearfix">
        <div class="ccui-notice-app-container-detail-left">
          <div class="notice-title">{{ schemeObj.schemeName }}</div>
          <div class="notice-project-info">
            <div class="notice-project-info-li">
              <span>{{ $t("page.content.projectCode") }}：</span
              >{{ schemeObj.schemeCode }}
            </div>
            <div class="notice-project-info-li">
              <span>{{ $t("page.content.publishTime") }}：</span
              >{{ schemeObj.noticeStartTime }}
            </div>
            <!-- <div class="notice-project-info-li">
              <span>{{ $t("page.content.publishUnit") }}：</span
              >{{ schemeObj.opUnitName }}
            </div> -->
          </div>
        </div>
        <div class="ccui-notice-app-container-detail-right">
          <template v-if="schemeObj.isNotShowTime == '1'">
            <div class="notice-timeout-label">
              {{ $t("page.content.signUpEndTime") }}
            </div>
            <div class="notice-timeout-value" v-if="noticeEndTime">
              <i class="el-icon-time notice-icon-time"></i
              ><span class="time">{{ timeObj.day }}</span
              >{{ $t("page.content.day")
              }}<span class="time">{{ timeObj.hour }}</span
              >{{ $t("page.content.hour")
              }}<span class="time">{{ timeObj.minute }}</span
              >{{ $t("page.content.minute")
              }}<span class="time">{{ timeObj.second }}</span
              >{{ $t("page.content.second") }}
            </div>
            <p class="timeBox" v-else>
              {{ $t("page.content.noticeDetail") }}
            </p>
          </template>
          <template>
            <el-button
              :class="[
                'notice-timeout-btn',
                schemeObj.isNotShowTime == '1'
                  ? 'notice-timeout-btn-bottom'
                  : ''
              ]"
              size="mini"
              :disabled="accessToken && isFBSupCode != 10000 ? false : true"
              type="primary-font-mini"
              v-if="
                !(
                  this.$route.query.schemeStatus !== '3' ||
                  (this.checkFlag !== '2' &&
                    this.checkFlag !== '4' &&
                    this.checkFlag !== '5')
                )
              "
              @click="
                signUpFB({
                  schemeId: $route.query.schemeId,
                  purchaseType: $route.query.purchaseType,
                  noticeStartTime: schemeObj.noticeStartTime,
                  schemeCode: schemeObj.schemeCode,
                  schemeName: schemeObj.schemeName,
                  supName: $route.query.supName,
                  supCode: $route.query.supCode
                })
              "
              >{{ $t("page.content.immediatelySignUpFB") }}</el-button
            >
            <!--进入项目-->
            <template
              v-else-if="this.checkFlag !== '1' && this.checkFlag !== '4'"
            >
              <el-button
                :class="[
                  'notice-timeout-btn',
                  schemeObj.isNotShowTime == '1'
                    ? 'notice-timeout-btn-bottom-project'
                    : ''
                ]"
                size="mini"
                :disabled="accessToken && isFBSupCode != 10000 ? false : true"
                type="primary-font-mini"
                @click="
                  toProjectFB({
                    schemeId: $route.query.schemeId,
                    purchaseType: $route.query.purchaseType,
                    noticeStartTime: schemeObj.noticeStartTime,
                    noticeEndTime: schemeObj.noticeEndTime,
                    schemeCode: schemeObj.schemeCode,
                    schemeName: schemeObj.schemeName,
                    supName: $route.query.supName,
                    supCode: $route.query.supCode
                  })
                "
              >
                <template v-if="accessToken">
                  <span v-if="isFBSupCode != 10000">
                    {{ $t("page.content.toMyProject") }}</span
                  >
                  <span v-if="isFBSupCode == 10000"> 仅分包商可进入项目</span>
                </template>
                <template v-else>
                  {{ $t("page.content.toMyProject") }}
                  {{ accessToken ? "" : "（请先登录）" }}
                </template>
              </el-button>
            </template>
            <template v-else>
              <el-button
                :class="[
                  'notice-timeout-btn',
                  schemeObj.isNotShowTime == '1'
                    ? 'notice-timeout-btn-bottom'
                    : ''
                ]"
                size="mini"
                type="primary-font-mini"
                :disabled="true"
                >{{ $t("page.content.immediatelySignUpFB")
                }}{{ accessToken ? "" : "（请先登录）" }}</el-button
              >
            </template>
          </template>
        </div>
      </div>
    </div>
    <div class="template-notice-detail-body ccui-clearfix">
      <!--左侧内容-->
      <div
        class="template-notice-detail-left"
        :style="{
          'min-height': leftMinHeight,
          width: '1120px'
        }"
      >
        <div class="notice-detail-title">{{ $t("page.content.notice") }}</div>
        <div class="notice-detail-ul clearfix">
          <div class="notice-detail-li ccui-clearfix">
            <span class="notice-detail-li-title"
              >{{ $t("page.content.noticeTitle") }}：</span
            >
            <div class="notice-detail-li-con">{{ pageData.noticeTitle }}</div>
          </div>
          <div class="notice-detail-li ccui-clearfix">
            <span class="notice-detail-li-title"
              >{{ $t("page.content.noticeContent") }}：</span
            >
            <div class="notice-detail-li-con" v-html="pageData.textInfo"></div>
          </div>
          <!-- <div
            class="notice-detail-li ccui-clearfix"
            v-if="
              $route.query.purchaseType === '0' ||
                $route.query.purchaseType === '3'
            "
          >
            <span class="notice-detail-li-title"
              >{{ $t("page.content.contractInfo") }}：</span
            >
            <div class="notice-detail-li-con" v-html="pageData.linkInfo"></div>
          </div> -->
        </div>
        <div class="notice-detail-title" style="padding-top: 40px">
          {{ $t("page.content.fileList") }}
          <!-- <span class="notice-detail-title-tip">
            <el-link type="danger" @click="handleProcess">{{
              $t("page.content.supplierBiddingProcess")
            }}</el-link>
            <span class="fontsize-14"
              >（{{ $t("page.content.pleaseClickView") }}）</span
            >
          </span> -->
        </div>

        <detailTable
          class="dic-sub-table-style01"
          v-if="accessToken && isFBSupCode != 10000"
          :tableData="pageData.fileinfoBOS"
          :tableHead="fileHead"
          :typeTable="'FB'"
          :showIndex="true"
        ></detailTable>

        <detailTables
          class="dic-sub-table-style01"
          v-else
          :tableData="[{ id: 1 }]"
          :tableHead="fileHead"
          :showIndex="true"
        >
        </detailTables>

        <div>
          <!--包件信息-->
          <template v-for="(item, index) in packageList">
            <div :key="index">
              <template v-if="subPackageFlag === '1'">
                <div
                  class="notice-detail-title mt20 ellipsis"
                  :title="item.packName"
                >
                  {{ item.packName }}
                </div>
                <!-- <div class="notice-detail-explain ccui-clearfix">
                  <div class="fl">{{ $t("page.content.packageDesc") }}：</div>
                  <div style="line-break: anywhere;">
                    {{ item.packRequire }}
                  </div>
                </div> -->
              </template>
              <div class="notice-detail-title pt20" v-else></div>
              <template>
                <div class="notice-detail-subtitle">
                  {{ $t("page.content.quantitiesInfo") }}
                </div>
                <detailTable
                  class="dic-sub-table-style01"
                  :tableData="item.matDetailList"
                  v-if="accessToken && isFBSupCode != 10000"
                  :tableHead="packageHead"
                  :showIndex="true"
                ></detailTable>

                <detailTables
                  class="dic-sub-table-style01"
                  v-else
                  :tableData="[{ id: 1 }]"
                  :tableHead="packageHead"
                  :showIndex="true"
                ></detailTables>
              </template>
            </div>
          </template>
        </div>
        <div class="notice-detail-title pt20">
          {{ $t("page.content.relatedNoticeList") }}
        </div>
        <detailTable
          class="dic-sub-table-style01"
          :tableData="relateNoticeList"
          :tableHead="noticeHead"
          :showIndex="true"
        >
          <template slot="noticeTitle" slot-scope="{ row }">
            <el-button
              size="mini"
              type="text"
              @click="handleNoticeTitleFB(row)"
            >
              {{ row.noticeTitle }}
            </el-button>
          </template>
        </detailTable>
      </div>
    </div>
    <shareQRCode :code="code"></shareQRCode>
  </div>
</template>

<script>
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
import detailTable from "@/app/shop/components/detail-table";
import detailTables from "@/app/shop/components/detail-tables";
import shareQRCode from "@/app/shop/components/shareQRCode.vue";
import axios from "axios";
import { commonTableWidth } from "@/setting/setting";
// import noticeItemBlock from "@/app/shop/components/noticeItemBlock";
import { mixinHomePage } from "../../../mixins/mixin-common/mixin-homePage";
import globalConfig from "@/setting/setting";
import {
  qryNoticeDetail,
  queryProcessSchemeMatDetail,
  qryRelatedNoticeList
} from "@/app/shop/api/shopping";
import { qryFBSupJoinCheck } from "@/app/shop/api/shoppingSP";
import Cookies from "js-cookie";
// import $t from "@/app/shop/utils/translateUtil";

export default {
  name: "noticeDetail",
  mixins: [mixinHomePage],
  computed: {
    loginInfo() {
      return this.$store.getters.getLoginInfo;
    }
  },
  components: {
    baseBreadCrumb,
    detailTable,
    detailTables,
    shareQRCode
    // noticeItemBlock,
  },
  data() {
    return {
      code: "",
      currBreadCrumb: [
        { title: "采购公告", path: "/procurementNotice" },
        { title: "公开采购公告", path: "/procurementNotice" }
      ],
      propsCode: this.$route.query.supCode || null,
      fileHead: [
        { label: this.$t("page.content.fileName"), prop: "fileName" },
        {
          label: this.$t("page.content.fileSize"),
          prop: "fileSize",
          slot: "fileSize"
        },
        { label: this.$t("page.content.fileDesc"), prop: "fileSumm" },
        {
          label: this.$t("page.content.operation"),
          slot: "opp",
          align: "center"
        }
      ],
      packageHead: [
        { label: this.$t("page.content.code"), prop: "engerCode" },
        { label: this.$t("page.content.name"), prop: "engerName" },
        {
          label: this.$t("page.content.quantities"),
          prop: "quantities",
          slot: "quantities"
        },
        // { label: this.$t("page.content.unit"), prop: "unitName" },
        { label: this.$t("page.content.featRemark"), prop: "featRemark" },
        { label: this.$t("page.content.remark"), prop: "remark" }
      ],
      noticeHead: [
        {
          label: this.$t("page.content.types"),
          prop: "noticeTypeName",
          width: 150
        },
        {
          label: this.$t("page.content.title"),
          prop: "noticeTitle",
          slot: "noticeTitle"
        },
        // {
        //   label: this.$t("page.content.link"),
        //   prop: "purStepName",
        //   width: 150
        // },
        {
          label: this.$t("page.content.publishTime"),
          prop: "createTime",
          width: commonTableWidth.dateTimeWidth
        }
      ],
      subPackageFlag: "", //是否分包
      packageList: [],
      matDetailList: [],
      pageData: {},
      relateNoticeList: [], //相关公告列表
      schemeObj: {
        opUnitName: this.$route.query.opUnitName //发布单位
      },
      cumulativeAmount: 0, //累计金额
      projectNum: 0, //累计采购项目数
      inquiryProjectNum: 0, //询价项目数量
      competeProjectNum: 0, //竞价项目数量
      otherNoticeList: [], //该单位还在采购的公告列表
      noticeEndTime: "",
      timeObj: {
        day: 0,
        hour: 0,
        minute: 0,
        second: 0
      },
      timer: "",
      leftMinHeight: 0,
      checkFlag: "",
      supInfo: "",
      accessToken: "",
      isFBSupCode: ""
    };
  },

  activated() {
    if (
      sessionStorage.getItem("usedSupInfo") &&
      sessionStorage.getItem("usedSupInfo") != "undefined"
    ) {
      this.supInfo = JSON.parse(sessionStorage.getItem("usedSupInfo"));
    } else {
      this.supInfo = "";
    }
    this.isFBSupCode = sessionStorage.getItem("fbSupCode");
    this.accessToken = Cookies.get("access_token");
    // console.log(this.currBreadCrumb);
    this.currBreadCrumb[1].title =
      this.$route.query.noticeTypeName || "公开采购公告";
    this.init();
  },
  deactivated() {
    this.currBreadCrumb = [];
  },

  mounted() {
    this.shareQRCodeRequest();
  },
  methods: {
    shareQRCodeRequest() {
      const apiUrl =
        "https://aimarket.iccec.cn/api-v2/tender-api/info-qr/share";
      const params = {
        scene: this.$route.query.noticeId,
        path: "pages/home/detail"
      };
      axios
        .post(apiUrl, params)
        .then(response => {
          if (response.data.code === 0) {
            this.code = response.data.data;
          }
        })
        .catch(error => {
          console.error("分享二维码请求失败:", error);
        });
    },
    init() {
      let supCodeList = [];
      if (this.supInfo && this.$route.query.purchaseType !== "4") {
        supCodeList = [this.supInfo.supCode];
        // supCodeList = this.supInfo.map(item => {
        //   return item.supCode;
        // });
      } else {
        supCodeList.push(this.propsCode);
      }
      //登录情况下查询
      if (this.accessToken && this.supInfo) {
        //查询供应商是否可参与
        qryFBSupJoinCheck({
          schemeId: this.$route.query.schemeId,
          supCode: this.propsCode
          // supCodeList: supCodeList,
        }).then(res => {
          if (res.data.code === "0") {
            this.checkFlag = res.data.data.checkFlag;
          }
        });
      }

      //查询公告信息及附件列表
      qryNoticeDetail({
        schemeId: this.$route.query.schemeId,
        isLogin: this.accessToken ? 1 : 0,
        noticeId: this.$route.query.noticeId,
        // purStep: 1,
        qryFileFlag: true
      }).then(res => {
        if (res.data.code === "0" && res.data.data) {
          this.pageData = res.data.data;
          this.$set(
            this.noticeHead[2],
            "isHidden",
            this.pageData.purStep !== "1"
          );
          this.currBreadCrumb.push({
            title: this.pageData.noticeTitle
          });
          this.schemeObj.schemeName = this.pageData.schemeName;
          this.schemeObj.schemeCode = this.pageData.schemeCode;
          this.schemeObj.noticeStartTime = this.pageData.noticeStartTime;
          this.schemeObj.isNotShowTime = this.pageData.isNotShowTime;
          this.noticeEndTime = this.pageData.noticeExpectEndTime;
          if (this.noticeEndTime) {
            this.timer = setInterval(this.getTime, 1000);
          }
        }
      });
      //查询包件信息
      queryProcessSchemeMatDetail({
        supCode: this.propsCode,
        isLogin: this.accessToken && this.isFBSupCode != 10000 ? 1 : 0,
        schemeId: this.$route.query.schemeId
      }).then(res => {
        if (res.data.code === "0") {
          this.subPackageFlag = res.data.data.subPackageFlag;
          if (this.subPackageFlag === "0") {
            this.packageList = [{ matDetailList: res.data.data.matDetailList }];
          } else {
            this.packageList = res.data.data.packageList;
          }
        }
      });
      //查询相关公告列表
      qryRelatedNoticeList({
        schemeId: this.$route.query.schemeId,
        noticeId: this.$route.query.noticeId
      }).then(res => {
        if (res.data.code === "0") {
          this.relateNoticeList = res.data.data;
        }
      });

      // 单位累计金额和项目数量查询
      // qryUnitAmountAndProjectNum({
      //   opUnitId: this.$route.query.opUnitId
      // }).then(res => {
      //   if (res.data.code === "0") {
      //     this.cumulativeAmount = window.$computeUtil.getDividedToFormat(
      //       res.data.data.cumulativeAmount,
      //       10000
      //     );
      //     this.projectNum = res.data.data.projectNum;
      //     this.inquiryProjectNum = res.data.data.inquiryProjectNum;
      //     this.competeProjectNum = res.data.data.competeProjectNum;
      //   }
      // });

      //查询该单位还在采购的公告
      // listOpUnitBidNotice({
      //   pageNo: 1,
      //   pageSize: 2,
      //   purchaseType: this.$route.query.purchaseType,
      //   opUnitId: this.$route.query.opUnitId,
      //   noticeId: this.$route.query.noticeId,
      //   supCode: this.$store.state.user.supInfo.supCode,
      // }).then((res) => {
      //   if (res.data.code === "0") {
      //     this.otherNoticeList = res.data.data.rows;
      //     this.otherNoticeList.forEach((item) => {
      //       return (item.supCode = item.supCode
      //         ? item.supCode
      //         : this.propsCode);
      //     });
      //     this.$nextTick(() => {
      //       this.leftMinHeight = this.$refs.rightBox.clientHeight - 60 + "px";
      //     });
      //   }
      // });
    },
    getTime() {
      let obj =
        (new Date(this.noticeEndTime.replace(/-/g, "/")).getTime() -
          new Date().getTime()) *
        1000;
      if (obj < 0) {
        clearInterval(this.timer);
        return;
      }
      let day = Math.floor(obj / (24 * 3600 * 1000 * 1000));

      let leave1 = obj % (24 * 3600 * 1000 * 1000);
      let hour = Math.floor(leave1 / (3600 * 1000 * 1000));
      let leave2 = leave1 % (3600 * 1000 * 1000);
      let minutes = Math.floor(leave2 / (60 * 1000 * 1000));

      let leave3 = leave2 % (60 * 1000 * 1000);
      let second = Math.floor(leave3 / (1000 * 1000));

      this.timeObj.day = day;
      this.timeObj.hour = hour;
      this.timeObj.minute = minutes;
      this.timeObj.second = second;
    },

    //供应商在线投标流程
    handleProcess() {
      let url = this.$router.resolve({
        path: "/announcementDetail",
        query: {
          id: globalConfig.faqId,
          source: "1"
        }
      });
      window.open(url.href, "_blank");
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>

<style scoped lang="scss">
.template-detail-body .detail-box .detail-info {
  width: calc(100% - 240px);
}

/deep/ .template-detail-body .detail-box {
  margin-top: 20px;
  margin-bottom: 0;
}

/deep/
  .ccui-notice-app-container-detail
  .ccui-notice-app-container-detail-body
  .ccui-notice-app-container-detail-right {
  width: inherit;

  .notice-timeout-btn {
    margin-top: 92px;
    width: auto;
  }

  .notice-timeout-btn-bottom {
    margin-top: 32px;
  }

  .notice-timeout-btn-bottom-project {
    margin-top: 32px;
  }
}

.time {
  color: #ff142f;
  margin-left: 8px;
  margin-right: 8px;
}

.timeBox {
  font-weight: 500;
  font-size: 14px;
  color: #ff142f;
  margin-top: 5px;
  text-align: left;
}
</style>
